const config = {
  new_version_title: 'Important Update',
  new_version_1:
    'A new version of our application has just been released with some exciting changes. To fully experience the improvements and ensure the application functions properly, please refresh your browser window.',
  new_version_2: "Don't worry, you won't lose any of your work.",
  new_plugin_version_title: 'Refresh the active file',
  new_dev_plugin_version_title: 'There is new version available',
  new_plugin_ui_version_title: 'New plugin version available',
  new_plugin_version_text:
    'The new version of the plugin is available. To access it, manually reload the current tab.',
  new_dev_plugin_version_text:
    'The new version of the plugin is available. Ask the Velocity team for the new build. If you already have the new build please manually reload the current tab.',
  new_plugin_ui_version_text:
    'The new version of the plugin interface is available. To access it, press the button below.',
  actions: {
    refresh: 'Refresh',
  },
  errors: {
    cannot_load_manifest: 'Error loading config',
    ai_connection_lost:
      'Error occurred while trying to communicate to AI services',
  },
} as const;

export default config;
